import { IS_LOADING, ERROR } from "../../constants";

export { IS_LOADING, ERROR };

export const SET_HEADER_ANALYSE_RISQUES = "SET_HEADER_ANALYSE_RISQUES";
export const SET_CURRENT_ANALYSE_RISQUES_RISKS = "SET_CURRENT_ANALYSE_RISQUES_RISKS";

export const SET_PARTIAL_SPP = "SET_PARTIAL_SPP";

export const SET_REDIRECT_URL = "SET_REDIRECT_URL";
export const SET_EDITION_STATE = "SET_EDITION_STATE";

export const GET_RISK_TYPES = "GET_RISK_TYPES";
export const GET_INSTRUCTION_TYPES = "GET_INSTRUCTION_TYPES";

export const SET_SPP_COMPANIES = "SET_SPP_COMPANIES";
export const SET_RA_COMPANIES = "SET_RA_COMPANIES";

export const SET_ANALYSES_RISQUES = "SET_ANALYSES_RISQUES";
export const SET_FILTERED_ANALYSES_RISQUES = "SET_FILTERED_ANALYSES_RISQUES";
export const SET_VALIDATION_IN_PROGRESS_FILTER = "SET_VALIDATION_IN_PROGRESS_FILTER";
export const SET_NB_AR_TO_RESEND = "SET_NB_AR_TO_RESEND";
export const SET_NB_SPP_TO_RESEND = "SET_NB_SPP_TO_RESEND";

export const GET_PPE_LIST = "GET_PPE_LIST";
export const GET_ACCREDITATIONS_TYPES = "GET_ACCREDITATIONS_TYPES";

export const SET_ICP_PARTICIPANTS = "SET_ICP_PARTICIPANTS";

export const SET_MODULE = "SET_MODULE";

export const SET_SPP_FOUND = "SET_SPP_FOUND";

export const SET_NB_COMPANIES_DISPLAY = "SET_NB_COMPANIES_DISPLAY";

export const NB_PARTICIPANT_MAX = 9; //EU + 8 participants extérieurs
